import { render, staticRenderFns } from "./SectionDetailPricing.vue?vue&type=template&id=20e22dc6&"
import script from "./SectionDetailPricing.vue?vue&type=script&lang=js&"
export * from "./SectionDetailPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports